var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanyTypeManufacturer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65.632,
    height: 54.424,
    viewBox: "0 0 65.632 54.424",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "company_type_manufacturer_clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3617",
    "data-name": "Rectangle 3617",
    width: 65.632,
    height: 54.424,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3327",
    "data-name": "Group 3327",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3250",
    "data-name": "Group 3250",
    transform: "translate(0 0)",
    clipPath: "url(#company_type_manufacturer_clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3545",
    "data-name": "Path 3545",
    d: "M17.442,44.048a1.05,1.05,0,0,0,1.011,1.088l1.006.037H19.5a1.05,1.05,0,0,0,.038-2.1l-1.006-.037a1.047,1.047,0,0,0-1.088,1.011",
    transform: "translate(-7.462 -18.411)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3546",
    "data-name": "Path 3546",
    d: "M17.442,44.048a1.05,1.05,0,0,0,1.011,1.088l1.006.037H19.5a1.05,1.05,0,0,0,.038-2.1l-1.006-.037A1.047,1.047,0,0,0,17.442,44.048Z",
    transform: "translate(-7.462 -18.411)",
    fill: "currentColor",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3547",
    "data-name": "Path 3547",
    d: "M14.624,37.058l.908.435A1.05,1.05,0,1,0,16.44,35.6l-.908-.435a1.05,1.05,0,0,0-.908,1.894",
    transform: "translate(-6.001 -14.999)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3548",
    "data-name": "Path 3548",
    d: "M14.624,37.058l.908.435A1.05,1.05,0,1,0,16.44,35.6l-.908-.435a1.05,1.05,0,0,0-.908,1.894Z",
    transform: "translate(-6.001 -14.999)",
    fill: "currentColor",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3549",
    "data-name": "Path 3549",
    d: "M23.637,37.567a1.05,1.05,0,0,0,1.68-1.261l-.605-.807a1.05,1.05,0,1,0-1.68,1.261Z",
    transform: "translate(-9.763 -15.007)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3550",
    "data-name": "Path 3550",
    d: "M23.637,37.567a1.05,1.05,0,0,0,1.68-1.261l-.605-.807a1.05,1.05,0,1,0-1.68,1.261Z",
    transform: "translate(-9.763 -15.007)",
    fill: "currentColor",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3551",
    "data-name": "Path 3551",
    d: "M46.395,49.3l.949.337a1.05,1.05,0,1,0,.7-1.979l-.949-.338a1.05,1.05,0,1,0-.7,1.979",
    transform: "translate(-19.549 -20.216)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3552",
    "data-name": "Path 3552",
    d: "M46.395,49.3l.949.337a1.05,1.05,0,1,0,.7-1.979l-.949-.338a1.05,1.05,0,1,0-.7,1.979Z",
    transform: "translate(-19.549 -20.216)",
    fill: "currentColor",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3553",
    "data-name": "Path 3553",
    d: "M38.506,47.677l-.879-.492A1.05,1.05,0,1,0,36.6,49.018l.879.492a1.05,1.05,0,1,0,1.025-1.833",
    transform: "translate(-15.429 -20.129)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3554",
    "data-name": "Path 3554",
    d: "M38.506,47.677l-.879-.492A1.05,1.05,0,1,0,36.6,49.018l.879.492a1.05,1.05,0,1,0,1.025-1.833Z",
    transform: "translate(-15.429 -20.129)",
    fill: "currentColor",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3555",
    "data-name": "Path 3555",
    d: "M42.9,41.027l-1.005-.077a1.05,1.05,0,1,0-.16,2.094l1.005.077.081,0a1.05,1.05,0,0,0,.079-2.1",
    transform: "translate(-17.439 -17.517)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3556",
    "data-name": "Path 3556",
    d: "M42.9,41.027l-1.005-.077a1.05,1.05,0,1,0-.16,2.094l1.005.077.081,0a1.05,1.05,0,0,0,.079-2.1Z",
    transform: "translate(-17.439 -17.517)",
    fill: "currentColor",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3557",
    "data-name": "Path 3557",
    d: "M64.227,51.669H59.641V49.048H61.6V22.276a4.894,4.894,0,0,0-3.439-4.666,4.229,4.229,0,0,0-.333-.377L41.4,1.537A4.168,4.168,0,0,0,37.326.549a4.19,4.19,0,0,0-1.081.336L19.309,8.914a4.2,4.2,0,0,0-2,5.584l1.556,3.3a4.15,4.15,0,0,0,.916,1.245L17.1,25.663a1.35,1.35,0,1,0,2.5,1.014l2.638-6.509a3.867,3.867,0,0,0,2.214-.372l12.462-5.908,7.838,7.491a4.894,4.894,0,0,0-.086.9V39.586l-9.524,2.8v6.661h1.65v2.621H24.1V44.515a4.89,4.89,0,0,0-3.582-4.7V29.169H10.741V39.812a4.89,4.89,0,0,0-3.581,4.7v7.154H1.725a1.35,1.35,0,0,0,0,2.7h62.5a1.35,1.35,0,1,0,0-2.7M23.294,17.354a1.476,1.476,0,0,1-.636.144,1.5,1.5,0,0,1-1.353-.857l-1.556-3.3a1.493,1.493,0,0,1,.715-1.989L32.012,5.881a4.178,4.178,0,0,0,1.079,4.355l1.73,1.653Zm11.663-9.07a1.493,1.493,0,0,1-.048-2.112l2.518-2.634a1.494,1.494,0,0,1,2.112-.048l14.547,13.9H49.548a4.868,4.868,0,0,0-3.5,1.488Zm2.882,36.124,8.369-2.461h5.824a1.35,1.35,0,0,0,0-2.7H47.364V22.276a2.186,2.186,0,0,1,2.185-2.184h7.168A2.187,2.187,0,0,1,58.9,22.276V46.347H37.839Zm1.65,4.64H56.94v2.621H39.489ZM13.442,31.87h4.373v7.76H13.442ZM9.86,44.515a2.187,2.187,0,0,1,2.185-2.185h7.168A2.187,2.187,0,0,1,21.4,44.515v7.154H9.86Z",
    transform: "translate(-0.16 -0.16)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3558",
    "data-name": "Path 3558",
    d: "M64.227,51.669H59.641V49.048H61.6V22.276a4.894,4.894,0,0,0-3.439-4.666,4.229,4.229,0,0,0-.333-.377L41.4,1.537A4.168,4.168,0,0,0,37.326.549a4.19,4.19,0,0,0-1.081.336L19.309,8.914a4.2,4.2,0,0,0-2,5.584l1.556,3.3a4.15,4.15,0,0,0,.916,1.245L17.1,25.663a1.35,1.35,0,1,0,2.5,1.014l2.638-6.509a3.867,3.867,0,0,0,2.214-.372l12.462-5.908,7.838,7.491a4.894,4.894,0,0,0-.086.9V39.586l-9.524,2.8v6.661h1.65v2.621H24.1V44.515a4.89,4.89,0,0,0-3.582-4.7V29.169H10.741V39.812a4.89,4.89,0,0,0-3.581,4.7v7.154H1.725a1.35,1.35,0,0,0,0,2.7h62.5a1.35,1.35,0,1,0,0-2.7ZM23.294,17.354a1.476,1.476,0,0,1-.636.144,1.5,1.5,0,0,1-1.353-.857l-1.556-3.3a1.493,1.493,0,0,1,.715-1.989L32.012,5.881a4.178,4.178,0,0,0,1.079,4.355l1.73,1.653Zm11.663-9.07a1.493,1.493,0,0,1-.048-2.112l2.518-2.634a1.494,1.494,0,0,1,2.112-.048l14.547,13.9H49.548a4.868,4.868,0,0,0-3.5,1.488Zm2.882,36.124,8.369-2.461h5.824a1.35,1.35,0,0,0,0-2.7H47.364V22.276a2.186,2.186,0,0,1,2.185-2.184h7.168A2.187,2.187,0,0,1,58.9,22.276V46.347H37.839Zm1.65,4.64H56.94v2.621H39.489ZM13.442,31.87h4.373v7.76H13.442ZM9.86,44.515a2.187,2.187,0,0,1,2.185-2.185h7.168A2.187,2.187,0,0,1,21.4,44.515v7.154H9.86Z",
    transform: "translate(-0.16 -0.16)",
    fill: "currentColor",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3559",
    "data-name": "Path 3559",
    d: "M91.721,39.007a1.351,1.351,0,0,0-1.35,1.35v.51a1.35,1.35,0,1,0,2.7,0v-.51a1.351,1.351,0,0,0-1.35-1.35",
    transform: "translate(-38.661 -16.687)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3560",
    "data-name": "Path 3560",
    d: "M91.721,39.007a1.351,1.351,0,0,0-1.35,1.35v.51a1.35,1.35,0,1,0,2.7,0v-.51A1.351,1.351,0,0,0,91.721,39.007Z",
    transform: "translate(-38.661 -16.687)",
    fill: "currentColor",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3561",
    "data-name": "Path 3561",
    d: "M91.721,48.154a1.351,1.351,0,0,0-1.35,1.35v.51a1.35,1.35,0,1,0,2.7,0V49.5a1.351,1.351,0,0,0-1.35-1.35",
    transform: "translate(-38.661 -20.6)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3562",
    "data-name": "Path 3562",
    d: "M91.721,48.154a1.351,1.351,0,0,0-1.35,1.35v.51a1.35,1.35,0,1,0,2.7,0V49.5A1.351,1.351,0,0,0,91.721,48.154Z",
    transform: "translate(-38.661 -20.6)",
    fill: "currentColor",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3563",
    "data-name": "Path 3563",
    d: "M67.239,10.16a1.35,1.35,0,0,0-1.8,2.017l.382.339a1.35,1.35,0,0,0,1.8-2.017Z",
    transform: "translate(-27.804 -4.2)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3564",
    "data-name": "Path 3564",
    d: "M67.239,10.16a1.35,1.35,0,0,0-1.8,2.017l.382.339a1.35,1.35,0,0,0,1.8-2.017Z",
    transform: "translate(-27.804 -4.2)",
    fill: "currentColor",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3565",
    "data-name": "Path 3565",
    d: "M39.737,20.76l-.469.2a1.35,1.35,0,1,0,1.063,2.482l.469-.2a1.35,1.35,0,1,0-1.063-2.482",
    transform: "translate(-16.448 -8.834)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3566",
    "data-name": "Path 3566",
    d: "M39.737,20.76l-.469.2a1.35,1.35,0,1,0,1.063,2.482l.469-.2a1.35,1.35,0,1,0-1.063-2.482Z",
    transform: "translate(-16.448 -8.834)",
    fill: "currentColor",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyTypeManufacturer);
export default __webpack_public_path__ + "static/media/company_type_manufacturer.b41496bd.svg";
export { ForwardRef as ReactComponent };